 
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useThemeColors } from '../hooks/useThemeColors';

// StyleSheet: SVG/absolute positioning for decorative elements
const styles = StyleSheet.create({
  rail: { position: 'absolute', height: 3, borderRadius: 2, opacity: 0.5 },
  trackWrap: { position: 'absolute', height: 20 },
  road: { position: 'absolute', borderRadius: 2, opacity: 0.45 },
});

function Rail({ color, top, left, right, width, rotation = 0 }: { color: string; top: number; left?: number | undefined; right?: number | undefined; width: number; rotation?: number | undefined}) {
  return (
    <View pointerEvents="none" style={[styles.rail, { top, left, right, width, backgroundColor: color, transform: [{ rotate: `${rotation}deg` }] }]} />
  );
}

function Track({ color, top, left, width, rotation = 0 }: { color: string; top: number; left?: number | undefined; width: number; rotation?: number | undefined}) {
  return (
    <View pointerEvents="none" style={[styles.trackWrap, { top, left, width, transform: [{ rotate: `${rotation}deg` }] }]}>
      <View style={[styles.rail, { left: 0, backgroundColor: color, width }]} />
      <View style={[styles.rail, { left: 0, top: 8, backgroundColor: color, width }]} />
    </View>
  );
}

function RoadSection({ color, top, left, right, width, height = 4 }: { color: string; top: number; left?: number | undefined; right?: number | undefined; width: number; height?: number | undefined}) {
  return (
    <View pointerEvents="none" style={[styles.road, { top, left, right, width, height, backgroundColor: color }]} />
  );
}

const HUE_RAMP_LIGHT = ['#C5E8C5', '#B8E0F0', '#E8EFF5', '#F5D5C8', '#F0E8F5'] as const;
const HUE_RAMP_DARK = ['#3F6A4E', '#3A6378', '#4A5566', '#7A4E42', '#5A4A60'] as const;

export function RoadRailDecoration() {
  const theme = useThemeColors();
  const isDark = theme.backgroundPage !== '#F9F9F7';
  const ramp = isDark ? HUE_RAMP_DARK : HUE_RAMP_LIGHT;
  return (
    <>
      <Rail color={ramp[0]} top={40} left={-50} width={120} rotation={-15} />
      <Track color={ramp[1]} top={90} left={-30} width={100} rotation={12} />
      <RoadSection color={ramp[2]} top={180} left={-20} width={150} />
      <Rail color={ramp[3]} top={220} right={50} width={80} rotation={-8} />
      <RoadSection color={ramp[4]} top={300} left={100} width={120} />
      <Track color={ramp[0]} top={340} left={-40} width={110} rotation={5} />
      <RoadSection color={ramp[1]} top={420} right={80} width={90} />
      <Rail color={ramp[2]} top={480} left={60} width={110} rotation={-10} />
    </>
  );
}
